import { useQuery } from "@tanstack/react-query";
import { getLeaderboard } from "../openapi/api-client.ts";

export const useLeaderboard = (
  competitionId: string | undefined,
  groupId: string | undefined,
) => {
  return useQuery({
    queryKey: ["leaderboard", { competitionId, groupId }],
    enabled: !!competitionId && !!groupId,
    queryFn: async () => {
      if (!competitionId) {
        throw new Error("competitionId is undefined");
      }

      if (!groupId) {
        throw new Error("groupId is undefined");
      }

      const data = await getLeaderboard({ competitionId, groupId });
      return data.data;
    },
  });
};
